import { FC, ReactNode, useEffect, useState } from 'react'
import { Table } from 'antd'
import { TableProps } from 'antd/lib/table/Table'
import { TablePaginationConfig } from 'antd/lib/table/interface'
import Pagination from '@templates/Pagination'
import { Wrapper } from './styled'

type Column = {
  title: ReactNode
  dataIndex?: string
  key?: string
  width?: number
  children?: Column[]
}

type TableData = Record<string, ReactNode> & {
  key: string
}

type PaginationConfig = TablePaginationConfig & {
  showLessItems?: boolean
}

type Props = {
  columns: Column[]
  data: TableData[]
  isLoading?: boolean
} & TableProps<any>

const TableComponent: FC<Props> = ({
  columns,
  data,
  isLoading,
  pagination = false,
  ...rest
}) => {
  const { className, ...props } = rest
  const tableClassName = `standard-pagination ${className || ''}`.trim()
  const paginationConfig = pagination
    ? (pagination as PaginationConfig)
    : undefined
  const pageSize =
    paginationConfig?.pageSize || paginationConfig?.defaultPageSize || 10
  const defaultPage = paginationConfig?.defaultCurrent || 1
  const controlledPage = paginationConfig?.current
  const [localPage, setLocalPage] = useState(defaultPage)
  const currentPage = controlledPage ?? localPage

  useEffect(() => {
    if (controlledPage !== undefined) {
      setLocalPage(controlledPage)
    }
  }, [controlledPage])

  const handleChangePagination = (nextPage: number) => {
    setLocalPage(nextPage)
    paginationConfig?.onChange?.(nextPage, pageSize)
  }

  return (
    <Wrapper>
      <Table
        {...props}
        dataSource={data}
        columns={columns}
        className={tableClassName}
        pagination={false}
        bordered={false}
        loading={isLoading}
        rowClassName={(record) => record.className || ''}
      />
      {paginationConfig && (
        <Pagination
          page={currentPage}
          itemsCount={paginationConfig.total || 0}
          perPage={pageSize}
          onChangePagination={handleChangePagination}
        />
      )}
    </Wrapper>
  )
}

export type { TableData, Column }
export default TableComponent
